import React from 'react'

import ConductItem from '../conduct-item'

import styles from './styles.css'

const CollectionOfData = {
  title: 'COLLECTION OF YOUR INFORMATION',
  paragraph: [
    'We may collect information about you in a variety of ways. The information we may collect on the Site includes:',
  ],
  subitems: [
    {
      title: 'Personal Data',
      paragraph: [
        'Personally identifiable information, such as your name, shipping address, email address, and telephone number, and demographic information, such as your age, gender, hometown, and interests, that you voluntarily give to us when you register with the Site or when you choose to participate in various activities related to the Site, such as online chat and message boards. You are under no obligation to provide us with personal information of any kind, however your refusal to do so may prevent you from using certain features of the Site.',
      ],
    },
    {
      title: 'Financial Data',
      paragraph: [
        'Financial information, such as data related to your payment method (e.g. valid credit card number, card brand, expiration date) that we may collect when you purchase, order, return, exchange, or request information about our services from the Site.',
      ],
    },
    {
      title: 'Data from Social Networks',
      paragraph: [
        'User information from social networking sites, such as Facebook, including your name, your social network username, location, gender, birth date, email address, profile picture, and public data for contacts, if you connect your account to such social networks.',
      ],
    },
  ],
}

const UseOfYourInformation = {
  title: 'USE OF YOUR INFORMATION',
  paragraph: [
    'Having accurate information about you permits us to provide you with a smooth, efficient, and customized experience. Specifically, we may use information collected about you via the Site to:',
  ],
  items: [
    'Compile anonymous statistical data and analysis for use internally or with third parties.',
    'Create and manage your account.',
    'Email you regarding your account or order.',
    'Fulfill and manage purchases, orders, payments, and other transactions related to the Site.',
    'Increase the efficiency and operation of the Site.',
    'Monitor and analyze usage and trends to improve your experience with the Site.',
    'Notify you of updates to the Site.',
    'Offer new products, services, and/or recommendations to you.',
    'Perform other business activities as needed.',
    'Process payments and refunds.',
    'Request feedback and contact you about your use of the Site.',
    'Respond to product and customer service requests.',
    'Send you a newsletter.',
  ],
}

const Disclosure = {
  title: 'DISCLOSURE OF YOUR INFORMATION',
  paragraph: [
    'We may share information we have collected about you in certain situations. Your information may be disclosed as follows:',
  ],
  subitems: [
    {
      title: 'By Law or to Protect Rights',
      paragraph: [
        'If we believe the release of information about you is necessary to respond to legal process, to investigate or remedy potential violations of our policies, or to protect the rights, property, and safety of others, we may share your information as permitted or required by any applicable law, rule, or regulation. This includes exchanging information with other entities for fraud protection and credit risk reduction.',
      ],
    },
    {
      title: 'Third-Party Service Providers',
      paragraph: [
        'We may share your information with third parties that perform services for us or on our behalf, including payment processing, data analysis, email delivery, hosting services, customer services, and marketing assistance.',
      ],
    },
    {
      title: 'Interactions with Other Users',
      paragraph: [
        'If you interact with other users of the Site, those users may see your name, profile photo, and descriptions of your activity, including sending invitations to other users, chatting with other users, liking posts, following blogs.',
      ],
    },
    {
      title: 'Online Postings',
      paragraph: [
        'When you post comments, contributions or other content to the Site, your posts may be viewed by all users and may be publicly distributed outside the Site in perpetuity.',
      ],
    },
    {
      title: 'Affiliates',
      paragraph: [
        'We may share your information with our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include our parent company and any subsidiaries, joint venture partners or other companies that we control or that are under common control with us.',
      ],
    },
    {
      title: 'Social Media Contacts',
      paragraph: [
        'If you connect to the Site through a social network, your contacts on the social network will see your name, profile photo, and descriptions of your activity.',
      ],
    },
    {
      title: 'Other Third Parties',
      paragraph: [
        'We may share you information with advertisers and investors for the purpose of conducting general business analysis. We may also share your information with such third parties for marketing purposes, as permitted by law.',
      ],
    },
    {
      title: 'Sale or Bankruptcy',
      paragraph: [
        'If we reorganize or sell all or a portion of our assets, undergo a merger, or are acquired by another entity, we may transfer your information to the successor entity. If we go out of business or enter bankruptcy, your information would be an asset transferred or acquired by a third party. You acknowledge that such transfers may occur and that the transferee may decline honor commitments we made in this Privacy Policy.',
        'We are not responsible for the actions of third parties with whom you share personal or sensitive data, and we have no authority to manage or control third-party solicitations. If you no longer wish to receive correspondence, emails or other communications from third parties, you are responsible for contacting the third party directly.',
      ],
    },
  ],
}

const TrackingTechnologies = {
  title: 'TRACKING TECHNOLOGIES',
  subitems: [
    {
      title: 'Cookies and Web Beacons',
      paragraph: [
        'We may use cookies, web beacons, tracking pixels, and other tracking technologies on the Site to help customize the Site and improve your experience. When you access the Site, your personal information is not collected through the use of tracking technology. Most browsers are set to accept cookies by default. You can remove or reject cookies, but be aware that such action could affect the availability and functionality of the Site. You may not decline web beacons. However, they can be rendered ineffective by declining all cookies or by modifying your web browser’s settings to notify you each time a cookie is tendered, permitting you to accept or decline cookies on an individual basis.        ',
      ],
    },
  ],
}

const ThirdPartyWebsites = {
  title: 'THIRD-PARTY WEBSITES',
  paragraph: [
    'The Site may contain links to third-party websites and applications of interest, including advertisements and external services, that are not affiliated with us. Once you have used these links to leave the Site, any information you provide to these third parties is not covered by this Privacy Policy, and we cannot guarantee the safety and privacy of your information. Before visiting and providing any information to any third-party websites, you should inform yourself of the privacy policies and practices (if any) of the third party responsible for that website, and should take those steps necessary to, in your discretion, protect the privacy of your information. We are not responsible for the content or privacy and security practices and policies of any third parties, including other sites, services or applications that may be linked to or from the Site.',
  ],
}
const SecurityOfYourInformation = {
  title: 'SECURITY OF YOUR INFORMATION',
  paragraph: [
    'We use administrative, technical, and physical security measures to help protect your personal information. While we have taken reasonable steps to secure the personal information you provide to us, please be aware that despite our efforts, no security measures are perfect or impenetrable, and no method of data transmission can be guaranteed against any interception or other type of misuse. Any information disclosed online is vulnerable to interception and misuse by unauthorized parties. Therefore, we cannot guarantee complete safety of your information.    ',
  ],
}
const PolicyForChildren = {
  title: 'POLICY FOR CHILDREN',
  paragraph: [
    'We do not knowingly solicit information from or market to children under the age of 13. If you become aware of any data we have collected from children under age 13, please contact us using the contact information provided below.',
  ],
}

const ControlsForDoNotTrack = {
  title: 'CONTROLS FOR DO-NOT-TRACK FEATURES',
  paragraph: [
    'Most web browsers and some mobile operating systems include a Do-Not-Track (“DNT”) feature or setting you can activate to signal your privacy preference not to have data about your online browsing activities monitored and collected. No uniform technology standard for recognizing and implementing DNT signals has been finalized. As such, we do not currently respond to DNT browser signals or any other mechanism that automatically communicates your choice not to be tracked online. If a standard for online tracking is adopted that we must follow in the future, we will inform you about that practice in a revised version of this Privacy Policy.',
  ],
}

const OptionsRegardings = {
  title: 'OPTIONS REGARDING YOUR INFORMATION',
  subitems: [
    {
      title: 'Account Information',
      paragraph: [
        'You may at any time review or change the information in your account or terminate your account by logging into your user account settings and updating the user account.',
        'Upon your request to terminate your account, we will deactivate or delete your account and information from our active databases. However, some information may be retained in our files to prevent fraud, troubleshoot problems, assist with any investigations, enforce our Terms of Use and/or comply with legal requirements.',
      ],
    },
    {
      title: 'Emails and Communications',
      paragraph: [
        'If you no longer wish to receive correspondence, emails, or other communications from us, you may opt-out by logging into your user account settings and updating your preferences.',
        'If you no longer wish to receive correspondence, emails, or other communications from third parties, you are responsible for contacting the third party directly.',
      ],
    },
  ],
}
const CaliforniaPrivacy = {
  title: 'CALIFORNIA PRIVACY RIGHTS',
  paragraph: [
    'California Civil Code Section 1798.83, also known as the “Shine The Light” law, permits our users who are California residents to request and obtain from us, once a year and free of charge, information about categories of personal information (if any) we disclosed to third parties for direct marketing purposes and the names and addresses of all third parties with which we shared personal information in the immediately preceding calendar year. If you are a California resident and would like to make such a request, please submit your request in writing to us using the contact information provided below.',
    'If you are under 18 years of age, reside in California, and have a registered account with the Site, you have the right to request the removal of unwanted data that you publicly post on the Site. To request the removal of such data, please contact us using the contact information provided below, and include the email address associated with your account and a statement that you reside in California. We will make sure the data is not publicly displayed on the Site, but please be aware that the data not be completely or comprehensively removed from our systems.',
  ],
}

const ContactUs = {
  title: 'CONTACT US',
  paragraph: ['If you have questions or comments about this Privacy Policy, please contact us at:'],
}

const PrivacyPolicy = () => (
  <div className={styles.main}>
    <h1>Privacy Policy</h1>
    <h4>Last updated January 01, 2018</h4>
    <div className={styles.items}>
      <p>
        Conrad Group Inc. (“we” or “us” or “our”) respects the privacy of our users (“user” or
        “you”). This Privacy Policy explains how we collect, use, disclose, and safeguard your
        information when you visit our website Lightyearleadership.com, including any other media
        form, media channel, mobile website, or mobile application related or connected thereto
        (collectively, “the Site”). Please read this Privacy Policy carefully. By continuing to use
        the Site, you acknowledge that you have had the chance to review and consider this Privacy
        Policy, and you acknowledge that you agree to it. This means that you also consent to the
        use of your information and the method of disclosure as described in this Privacy Policy. If
        you do not understand the Privacy Policy or do not agree to it then you agree to immediately
        cease your use of the Site. We reserve the right to make changes to this Privacy Policy at
        any time and for any reason. We will alert you about any changes by updating the “Last
        updated” date at the top of this Privacy Policy. Any changes or modifications will be
        effective immediately upon posting the updated Privacy Policy on the Site, and you waive the
        right to receive specific notice of each such change or modification. You are encouraged to
        periodically review this Privacy Policy to stay informed of updates. You will be deemed to
        have been made aware of, will be subject to, and will be deemed to have accepted the changes
        in any revised Privacy Policy by your continued use of the Site after the date such revised
        Privacy Policy is posted.
      </p>
      <ConductItem title={CollectionOfData.title} subitems={CollectionOfData.subitems} />
      <ConductItem
        title={UseOfYourInformation.title}
        paragraphBefore={UseOfYourInformation.paragraph}
        dotItems={UseOfYourInformation.items}
      />
      <ConductItem
        title={Disclosure.title}
        paragraphBefore={Disclosure.paragraph}
        subitems={Disclosure.subitems}
      />
      <ConductItem
        title={Disclosure.title}
        paragraphBefore={Disclosure.paragraph}
        subitems={Disclosure.subitems}
      />
      <ConductItem title={TrackingTechnologies.title} subitems={TrackingTechnologies.subitems}>
        <div className={styles.subitems}>
          <h4 className={styles.title}>Web Analytics</h4>
          <p>
            We may also partner with selected third-party vendors, such as Google Analytics,
            Intercom, to allow tracking technologies and remarketing services on the Site through
            the use of first party cookies and third-party cookies, to, among other things, analyze
            and track users’ use of the Site, determine the popularity of certain content and better
            understand online activity. By accessing the Site, you consent to the collection and use
            of your information by these third-party vendors. You are encouraged to review their
            privacy policy and contact them directly for responses to your questions. We do not
            transfer personal information to these third-party vendors. However, if you do not want
            any information to be collected and used by tracking technologies, you can visit the
            third-party vendor or{' '}
            <a href="/dashboard">Network Advertising Initiative Opt-Out Tool</a> or{' '}
            <a href="/dashboard">Digital Advertising Alliance Opt-Out Tool</a>.
          </p>
          <p>
            You should be aware that getting a new computer, installing a new browser, upgrading an
            existing browser, or erasing or otherwise altering your browser’s cookies files may also
            clear certain opt-out cookies, plugins, or settings.
          </p>
        </div>
      </ConductItem>
      <ConductItem
        title={ThirdPartyWebsites.title}
        paragraphBefore={ThirdPartyWebsites.paragraph}
      />
      <ConductItem
        title={SecurityOfYourInformation.title}
        paragraphAfter={SecurityOfYourInformation.paragraph}
      />
      <ConductItem title={PolicyForChildren.title} paragraphAfter={PolicyForChildren.paragraph} />
      <ConductItem
        title={ControlsForDoNotTrack.title}
        paragraphAfter={ControlsForDoNotTrack.paragraph}
      />
      <ConductItem title={OptionsRegardings.title} subitems={OptionsRegardings.subitems} />
      <ConductItem title={CaliforniaPrivacy.title} paragraphBefore={CaliforniaPrivacy.paragraph} />
      <ConductItem title={ContactUs.title} contactUs paragraphBefore={ContactUs.paragraph} />
    </div>
  </div>
)

export default PrivacyPolicy
